import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BenchTemplateListComponent } from './bench-template-list/bench-template-list.component';

import { AuthGuard } from '@core/utilities/auth.guard';
import { RedeploymentAuthorize } from '@core/utilities/redeployment-authorize.guard';
import { Permission } from '@core/literals/permission.literal';
import { BenchTemplateComponent } from './bench-template/bench-template.component';
import { Organizations } from '../../shared/literals/shared.literal';
import { Services } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: '',
    component: BenchTemplateListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewBenchTemplates, Services.GenerateBenchTemplate))]
  },
  {
    path: 'BenchTemplate/Detail/:id',
    component: BenchTemplateComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.UpdateBenchTemplate, Services.GenerateBenchTemplate))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class BenchTemplatesRoutingModule {

}
